import { render } from "./B2bPageAuditoriaAcciones.vue?vue&type=template&id=691e08d0&scoped=true&lang=pug"
import script from "./B2bPageAuditoriaAcciones.vue?vue&type=script&lang=js"
export * from "./B2bPageAuditoriaAcciones.vue?vue&type=script&lang=js"

import "./B2bPageAuditoriaAcciones.vue?vue&type=style&index=0&id=691e08d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-691e08d0"]])

export default __exports__